import React from "react";
import { useNavigate } from "react-router-dom";

export default function MobileBackButton({ to = "/store", className = "", fixed = true }) {
  const nav = useNavigate();
  function goBack() {
    try {
      if (window.history.length > 1) {
        nav(-1);
      } else {
        nav(to);
      }
    } catch {
      nav(to);
    }
  }
  const base = [
    "md:hidden inline-flex items-center justify-center",
    "h-10 w-10 rounded-full border bg-white/90 backdrop-blur shadow-sm hover:bg-gray-50",
  ];
  const pos = fixed ? "fixed top-2 left-2 z-40" : "relative z-0";
  return (
    <button
      type="button"
      onClick={goBack}
      className={[pos, ...base, className].join(" ")}
      title="Back"
      aria-label="Back"
    >
      {/* left chevron icon */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-5 w-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
  );
}
